@if (textModeEnabled) {
  <div class="input-group" [class.has-error]="!textDateControl.valid">
    <input aria-label="Text Date" class="form-control text-mode-input text-uppercase" type="text"
      placeholder="NOW-14DAYS" [formControl]="textDateControl" (ngModelChange)="textDateUpdated()"
      [disabled]="disabled" data-cy="DateInput">
    <div class="input-group-append">
      <button type="button" class="btn btn-info btn-sm" (click)="disableTextMode()" title="Enter date selection">
        <i class="fal fa-calendar"></i>
      </button>
      <button type="button" class="btn btn-info btn-sm" [disabled]="true" title="Enter textual dates">
        <i class="fal fa-i-cursor"></i>
      </button>
      <small class="mx-2 my-1 text-muted">
        Ex.
        <code class="me-1">NOW</code>
        <code class="me-1">NOW-14DAYS</code>
        <code class="me-1">NOW/MONTH+1MONTH</code>
      </small>
    </div>
  </div>
} @else {
  <rl-date-input [(ngModel)]="dateValue" (ngModelChange)="dateUpdated()" [onlyValidDates]="true">
    <div input-group-append>
      <button type="button" class="btn btn-info btn-sm" [disabled]="true" title="Enter date selection">
        <i class="fal fa-calendar"></i>
      </button>
      <button type="button" class="btn btn-info btn-sm" (click)="enableTextMode()" title="Enter textual dates">
        <i class="fal fa-i-cursor"></i>
      </button>
    </div>
  </rl-date-input>
}
